const EmptyImage = () => (
  <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M37.5 21C39.9853 21 42 18.9853 42 16.5C42 14.0147 39.9853 12 37.5 12C35.0147 12 33 14.0147 33 16.5C33 18.9853 35.0147 21 37.5 21Z" fill="#F2F4F8"/>
    <path d="M0 6C0 2.68629 2.68629 0 6 0H48C51.3137 0 54 2.68629 54 6V48C54 51.3137 51.3137 54 48 54H6C2.68629 54 0 51.3137 0 48V6ZM48 6H6V29.7582L16.126 21.6574C17.2217 20.7809 18.7785 20.7809 19.8742 21.6574L32.7775 31.98L36.8788 27.8787C38.0504 26.7071 39.9499 26.7071 41.1214 27.8787L48 34.7572V6ZM6 48H48V43.2425L39.0001 34.2426L35.1214 38.1213C34.0405 39.2022 32.3197 39.2975 31.126 38.3426L18.0001 27.8419L6 37.442V48Z" fill="#F2F4F8"/>
  </svg>
);

export default EmptyImage;
